import Pagination from '../vc-pagination/locale/ku_IQ'
import DatePicker from '../date-picker/locale/ku_IQ'
import TimePicker from '../time-picker/locale/ku_IQ'
import Calendar from '../calendar/locale/ku_IQ'

export default {
  locale: 'ku-iq',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Menuê peldanka',
    filterConfirm: 'Temam',
    filterReset: 'Jê bibe',
    emptyText: 'Agahî tune',
    selectAll: 'Hemî hilbijêre',
    selectInvert: 'Hilbijartinan veguhere',
  },
  Modal: {
    okText: 'Temam',
    cancelText: 'Betal ke',
    justOkText: 'Temam',
  },
  Popconfirm: {
    okText: 'Temam',
    cancelText: 'Betal ke',
  },
  Transfer: {
    notFoundContent: 'Peyda Nebû',
    searchPlaceholder: 'Lêgerîn',
    itemUnit: 'tişt',
    itemsUnit: 'tişt',
  },
  Select: {
    notFoundContent: 'Peyda Nebû',
  },
  Upload: {
    uploading: 'Bardike...',
    removeFile: 'Pelê rabike',
    uploadError: 'Xeta barkirine',
    previewFile: 'Pelê pêşbibîne',
  },
}



// WEBPACK FOOTER //
// ./components/locale-provider/ku_IQ.js